// extracted by mini-css-extract-plugin
export var pageBody = "TikTakBoom-module--pageBody--2K1jH";